module.exports = __webpack_public_path__ + "img/animation2.c861b7b1.png";